export const en = {
  'access.page.title': 'Access control',
  'access.page.description': 'The lanes that let people in, and who is walking through them right now.',
  'access.page.readers': 'Readers',
  'access.page.events': 'Events',
  'access.page.zones': 'Zones',
  'access.page.shadow': 'Shadow run',
  'access.page.test': 'Test scan',
  'access.field.when': 'When',
  'access.field.member': 'Member',
  'access.field.reader': 'Reader',
  'access.field.direction': 'Direction',
  'access.field.result': 'Result',
  'access.field.zone': 'Zone',
  'access.field.kind': 'Kind',
  'access.field.externalId': 'External ID',
  'access.field.ipAddress': 'IP address',
  'access.field.description': 'Description',
  'access.field.created': 'Created',
  'access.field.membership': 'Membership',
  'access.field.ends': 'Ends',
  'access.unknown': 'Unknown',
  'access.editNamed': 'Edit {name}',
  'access.deleteNamed': 'Delete {name}',
  'access.events.liveInstant': 'Live · instant updates',
  'access.events.livePolling': 'Live · refreshes every 5s',
  'access.events.updated': 'updated {when}',
  'access.events.allResults': 'All results',
  'access.events.emptyTitle': 'No access events yet',
  'access.events.emptyDescription': 'Events appear here as soon as a reader reports a scan, or when you run a test scan.',
  'access.readers.discover': 'Discover readers',
  'access.readers.discovered.one': '{count} reader discovered',
  'access.readers.discovered.other': '{count} readers discovered',
  'access.readers.add': 'Add reader',
  'access.readers.added': 'Reader added',
  'access.readers.updated': 'Reader updated',
  'access.readers.removed': 'Reader removed',
  'access.readers.emptyTitle': 'No readers yet',
  'access.readers.emptyDescription': 'Add a reader manually or discover them from the connected access-control provider.',
  'access.readers.lastSeen': 'Last seen',
  'access.readers.never': 'Never',
  'access.readers.address': 'Address',
  'access.readers.provider': 'Provider',
  'access.readers.enabled': 'Enabled',
  'access.readers.disabled': 'Disabled',
  'access.readers.remoteOpen': 'Remote open',
  'access.readers.open': 'Open',
  'access.readers.openTitle': 'Open {name}',
  'access.readers.openDescription': 'Sends a remote-open command to the reader and records an access event.',
  'access.readers.openNow': 'Open now',
  'access.readers.deleteTitle': 'Delete reader?',
  'access.readers.deleteDescription': '{name} will no longer accept scans. Past events are kept.',
  'access.readers.namePlaceholder': 'Main entrance turnstile',
  'access.readers.noZone': 'No zone',
  'access.readers.externalIdHint': 'Identifier used by the provider or agent',
  'access.zones.add': 'Add zone',
  'access.zones.added': 'Zone added',
  'access.zones.updated': 'Zone updated',
  'access.zones.emptyTitle': 'No zones',
  'access.zones.emptyDescription': 'Zones group readers (e.g. gym floor, pool, sauna) so plans can restrict where members may go.',
  'access.zones.externalIdHint': 'Zone identifier in the access-control provider',
  'access.shadow.intro': 'For every tap the on-site terminals decide and mirror into Bulk, Bulk also computes what it would have decided. This is the parallel-run evidence that Bulk agrees with the live door before any cutover.',
  'access.shadow.emptyTitle': 'No mirrored taps scored yet',
  'access.shadow.emptyDescription': 'Once the on-site agent mirrors terminal events, each one is scored against the platform decision and the agreement appears here.',
  'access.shadow.agreement': 'Agreement',
  'access.shadow.agreementHint': 'of cards Bulk could resolve',
  'access.shadow.agreed': 'Agreed',
  'access.shadow.disagreed': 'Disagreed',
  'access.shadow.unresolved': 'Unresolved cards',
  'access.shadow.unresolvedHint': 'not yet imported into Bulk',
  'access.shadow.noDisagreements': 'No disagreements among resolvable cards.',
  'access.shadow.noDisagreementsAcross.one': 'No disagreements among resolvable cards across {count} scored tap.',
  'access.shadow.noDisagreementsAcross.other': 'No disagreements among resolvable cards across {count} scored taps.',
  'access.shadow.door': 'Door',
  'access.shadow.bulkReason': 'Bulk reason',
  'access.test.intro': 'Run the same decision the door would make, and record it as a real access event.',
  'access.test.credentialType': 'Credential type',
  'access.test.credentialValue': 'Credential value',
  'access.test.credentialPlaceholder': 'Scan or type the card value',
  'access.test.noReader': 'No specific reader',
  'access.test.readerDefault': 'Reader default',
  'access.test.run': 'Run test scan',
  'access.test.granted': 'Access granted',
  'access.test.denied': 'Access denied',
  'access.test.viewMember': 'View member',
  'access.test.waiting': 'The decision will appear here.',
  'access.page.harvest': 'From the old system',
  'access.harvest.intro': 'Card holders seen tapping in on the old access system. Promote them to make each one a member with their card: a customer keeps the old membership and its end date, on a hidden plan of the same name; a staff card goes on the free Staff plan.',
  'access.harvest.total': 'Holders seen',
  'access.harvest.lastWeek.one': '{count} seen in the last 7 days',
  'access.harvest.lastWeek.other': '{count} seen in the last 7 days',
  'access.harvest.withCard': 'With a card',
  'access.harvest.staffCards': 'Staff cards',
  'access.harvest.promoted': 'Promoted',
  'access.harvest.kind': 'Show',
  'access.harvest.kind.ALL': 'All',
  'access.harvest.kind.CUSTOMER': 'Customers',
  'access.harvest.kind.STAFF': 'Staff',
  'access.harvest.onlyUnpromoted': 'Not promoted yet',
  'access.harvest.search': 'Name or old customer number',
  'access.harvest.promote.one': 'Promote {count} holder',
  'access.harvest.promote.other': 'Promote {count} holders',
  'access.harvest.promotedDone.one': '{count} holder promoted',
  'access.harvest.promotedDone.other': '{count} holders promoted',
  'access.harvest.selectAll': 'Select every holder on this page',
  'access.harvest.select': 'Select {name}',
  'access.harvest.col.name': 'Name',
  'access.harvest.col.card': 'Card',
  'access.harvest.col.membership': 'Old membership',
  'access.harvest.col.ends': 'Ends',
  'access.harvest.col.credits': 'Visits left',
  'access.harvest.col.lastSeen': 'Last seen',
  'access.harvest.col.inBulk': 'In Bulk',
  'access.harvest.staffCard': 'Staff card',
  'access.harvest.openMember': 'Open member',
  'access.harvest.notYet': 'Not yet',
  'access.harvest.emptyTitle': 'Nobody seen yet',
  'access.harvest.emptyDescription': 'Once the on-site agent reads the old system’s taps, everyone who taps in appears here.',
  'access.harvest.promotionOff': 'Bulk has turned off promoting these card holders to members for this gym. You can still see who was collected; ask Bulk if you need promotion back.',
  'access.harvest.result.noMembership.one': '{count} promoted without a membership: the old system gave no end date we could read, so reception sells one',
  'access.harvest.result.noMembership.other': '{count} promoted without a membership: the old system gave no end date we could read, so reception sells one',
  'access.harvest.result.ended.one': '{count} promoted with a membership that had already ended',
  'access.harvest.result.ended.other': '{count} promoted with a membership that had already ended',
  'access.harvest.result.left': 'Left out',
  'access.harvest.outcome.PROMOTED': 'Promoted',
  'access.harvest.outcome.ALREADY_PROMOTED': 'Already a member',
  'access.harvest.outcome.NO_NAME': 'No name on the old record',
  'access.harvest.outcome.NO_CARD': 'No card number',
  'access.harvest.outcome.CARD_IN_USE': 'The card already belongs to another member',
  'access.readers.purpose': 'What it is for',
  'access.readers.purpose.DOOR': 'Door (opens for members)',
  'access.readers.purpose.STAFF_CLOCK': 'Staff clock (clocks staff in and out, never opens)',
  'access.readers.staffClock': 'Staff clock',
};

export const ka: Record<keyof typeof en, string> = {
  'access.page.title': 'დაშვების კონტროლი',
  'access.page.description': 'ტურნიკეტები, რომლებიც ხალხს შემოუშვებს, და ვინ გადის მათში ამ წუთას.',
  'access.page.readers': 'წამკითხველები',
  'access.page.events': 'მოვლენები',
  'access.page.zones': 'ზონები',
  'access.page.shadow': 'პარალელური შემოწმება',
  'access.page.test': 'სატესტო სკანირება',
  'access.field.when': 'დრო',
  'access.field.member': 'წევრი',
  'access.field.reader': 'წამკითხველი',
  'access.field.direction': 'მიმართულება',
  'access.field.result': 'შედეგი',
  'access.field.zone': 'ზონა',
  'access.field.kind': 'ტიპი',
  'access.field.externalId': 'გარე ID',
  'access.field.ipAddress': 'IP მისამართი',
  'access.field.description': 'აღწერა',
  'access.field.created': 'შექმნის თარიღი',
  'access.field.membership': 'აბონემენტი',
  'access.field.ends': 'მთავრდება',
  'access.unknown': 'უცნობი',
  'access.editNamed': 'რედაქტირება: {name}',
  'access.deleteNamed': 'წაშლა: {name}',
  'access.events.liveInstant': 'რეალურ დროში · მყისიერი განახლება',
  'access.events.livePolling': 'რეალურ დროში · ახლდება ყოველ 5 წამში',
  'access.events.updated': 'განახლდა {when}',
  'access.events.allResults': 'ყველა შედეგი',
  'access.events.emptyTitle': 'შესვლების ჟურნალი ჯერ ცარიელია',
  'access.events.emptyDescription': 'მოვლენები აქ გამოჩნდება, როგორც კი წამკითხველი სკანირებას დააფიქსირებს ან სატესტო სკანირებას გაუშვებთ.',
  'access.readers.discover': 'წამკითხველების მოძიება',
  'access.readers.discovered.one': 'მოიძებნა {count} წამკითხველი',
  'access.readers.discovered.other': 'მოიძებნა {count} წამკითხველი',
  'access.readers.add': 'წამკითხველის დამატება',
  'access.readers.added': 'წამკითხველი დაემატა',
  'access.readers.updated': 'წამკითხველი განახლდა',
  'access.readers.removed': 'წამკითხველი წაიშალა',
  'access.readers.emptyTitle': 'წამკითხველები ჯერ არ არის',
  'access.readers.emptyDescription': 'დაამატეთ წამკითხველი ხელით ან მოიძიეთ ისინი დაკავშირებულ დაშვების კონტროლის პროვაიდერში.',
  'access.readers.lastSeen': 'ბოლო კავშირი',
  'access.readers.never': 'არასდროს',
  'access.readers.address': 'მისამართი',
  'access.readers.provider': 'პროვაიდერი',
  'access.readers.enabled': 'ჩართული',
  'access.readers.disabled': 'გამორთული',
  'access.readers.remoteOpen': 'დისტანციური გაღება',
  'access.readers.open': 'გაღება',
  'access.readers.openTitle': 'გაღება: {name}',
  'access.readers.openDescription': 'წამკითხველს დისტანციური გაღების ბრძანებას უგზავნის და ჩანაწერს შესვლების ჟურნალში ამატებს.',
  'access.readers.openNow': 'გაღება ახლა',
  'access.readers.deleteTitle': 'წავშალოთ წამკითხველი?',
  'access.readers.deleteDescription': '„{name}“ სკანირებებს აღარ მიიღებს. წინა მოვლენები შენარჩუნდება.',
  'access.readers.namePlaceholder': 'მთავარი შესასვლელის ტურნიკეტი',
  'access.readers.noZone': 'ზონის გარეშე',
  'access.readers.externalIdHint': 'იდენტიფიკატორი, რომელსაც პროვაიდერი ან აგენტი იყენებს',
  'access.zones.add': 'ზონის დამატება',
  'access.zones.added': 'ზონა დაემატა',
  'access.zones.updated': 'ზონა განახლდა',
  'access.zones.emptyTitle': 'ზონები არ არის',
  'access.zones.emptyDescription': 'ზონები წამკითხველებს აჯგუფებს (მაგ. სავარჯიშო დარბაზი, აუზი, საუნა), რათა პაკეტებით შეიზღუდოს, სად შეუძლიათ წევრებს შესვლა.',
  'access.zones.externalIdHint': 'ზონის იდენტიფიკატორი დაშვების კონტროლის პროვაიდერთან',
  'access.shadow.intro': 'ყოველ სკანირებაზე, რომელზეც გადაწყვეტილებას ადგილობრივი ტერმინალები იღებენ და Bulk-ში ასახავენ, Bulk თავადაც ითვლის, რას გადაწყვეტდა. პარალელური შემოწმება ადასტურებს, რომ Bulk მოქმედ კარს ეთანხმება, სანამ დაშვების მართვა Bulk-ზე გადავა.',
  'access.shadow.emptyTitle': 'ასახული სკანირებები ჯერ არ შეფასებულა',
  'access.shadow.emptyDescription': 'როგორც კი ადგილობრივი აგენტი ტერმინალის მოვლენებს ასახავს, თითოეული პლატფორმის გადაწყვეტილებას შედარდება და დამთხვევის მაჩვენებელი აქ გამოჩნდება.',
  'access.shadow.agreement': 'დამთხვევის მაჩვენებელი',
  'access.shadow.agreementHint': 'იმ ბარათებიდან, რომლებიც Bulk-მა ამოიცნო',
  'access.shadow.agreed': 'დაემთხვა',
  'access.shadow.disagreed': 'არ დაემთხვა',
  'access.shadow.unresolved': 'ამოუცნობი ბარათები',
  'access.shadow.unresolvedHint': 'Bulk-ში ჯერ არ არის იმპორტირებული',
  'access.shadow.noDisagreements': 'ამოცნობად ბარათებზე შეუსაბამობა არ არის.',
  'access.shadow.noDisagreementsAcross.one': '{count} შეფასებულ სკანირებაში ამოცნობად ბარათებზე შეუსაბამობა არ არის.',
  'access.shadow.noDisagreementsAcross.other': '{count} შეფასებულ სკანირებაში ამოცნობად ბარათებზე შეუსაბამობა არ არის.',
  'access.shadow.door': 'კარი',
  'access.shadow.bulkReason': 'Bulk-ის მიზეზი',
  'access.test.intro': 'შეამოწმეთ, რა გადაწყვეტილებას მიიღებდა კარი — შედეგი შესვლების ჟურნალში ნამდვილი მოვლენის სახით ჩაიწერება.',
  'access.test.credentialType': 'ბარათის ან კოდის ტიპი',
  'access.test.credentialValue': 'ბარათის ან კოდის მნიშვნელობა',
  'access.test.credentialPlaceholder': 'დაასკანერეთ ბარათი ან აკრიფეთ მისი ნომერი',
  'access.test.noReader': 'კონკრეტული წამკითხველის გარეშე',
  'access.test.readerDefault': 'წამკითხველის ნაგულისხმევი მიმართულება',
  'access.test.run': 'სატესტო სკანირების გაშვება',
  'access.test.granted': 'დაშვებულია',
  'access.test.denied': 'დაშვებაზე უარი',
  'access.test.viewMember': 'წევრის ნახვა',
  'access.test.waiting': 'გადაწყვეტილება აქ გამოჩნდება.',
  'access.page.harvest': 'ძველი სისტემიდან',
  'access.harvest.intro': 'ბარათის მფლობელები, რომლებიც ძველ დაშვების სისტემაში შემოვიდნენ. გადაიყვანეთ ისინი და თითოეული გახდება წევრი თავისი ბარათით: მომხმარებელი ინარჩუნებს ძველ აბონემენტს და მის დასრულების თარიღს იმავე სახელის დამალულ გეგმაზე; პერსონალის ბარათი უფასო „პერსონალის“ გეგმაზე გადადის.',
  'access.harvest.total': 'ნანახი მფლობელები',
  'access.harvest.lastWeek.one': 'ბოლო 7 დღეში ნანახია {count}',
  'access.harvest.lastWeek.other': 'ბოლო 7 დღეში ნანახია {count}',
  'access.harvest.withCard': 'ბარათით',
  'access.harvest.staffCards': 'პერსონალის ბარათები',
  'access.harvest.promoted': 'გადაყვანილი',
  'access.harvest.kind': 'ჩვენება',
  'access.harvest.kind.ALL': 'ყველა',
  'access.harvest.kind.CUSTOMER': 'მომხმარებლები',
  'access.harvest.kind.STAFF': 'პერსონალი',
  'access.harvest.onlyUnpromoted': 'ჯერ არ გადაყვანილი',
  'access.harvest.search': 'სახელი ან ძველი მომხმარებლის ნომერი',
  'access.harvest.promote.one': '{count} მფლობელის გადაყვანა',
  'access.harvest.promote.other': '{count} მფლობელის გადაყვანა',
  'access.harvest.promotedDone.one': 'გადაყვანილია {count} მფლობელი',
  'access.harvest.promotedDone.other': 'გადაყვანილია {count} მფლობელი',
  'access.harvest.selectAll': 'ამ გვერდის ყველა მფლობელის მონიშვნა',
  'access.harvest.select': '{name} — მონიშვნა',
  'access.harvest.col.name': 'სახელი',
  'access.harvest.col.card': 'ბარათი',
  'access.harvest.col.membership': 'ძველი აბონემენტი',
  'access.harvest.col.ends': 'დასრულება',
  'access.harvest.col.credits': 'დარჩენილი ვიზიტები',
  'access.harvest.col.lastSeen': 'ბოლოს ნანახი',
  'access.harvest.col.inBulk': 'Bulk-ში',
  'access.harvest.staffCard': 'პერსონალის ბარათი',
  'access.harvest.openMember': 'წევრის გახსნა',
  'access.harvest.notYet': 'ჯერ არა',
  'access.harvest.emptyTitle': 'ჯერ არავინ ჩანს',
  'access.harvest.emptyDescription': 'როცა ადგილობრივი აგენტი ძველი სისტემის სკანირებებს წაიკითხავს, ყველა, ვინც შემოვა, აქ გამოჩნდება.',
  'access.harvest.promotionOff': 'Bulk-მა ამ დარბაზისთვის გამორთო ბარათის მფლობელების წევრებად გადაყვანა. შეგროვებულთა სიას კვლავ ნახავთ; თუ გადაყვანა დაგჭირდებათ, მიმართეთ Bulk-ს.',
  'access.harvest.result.noMembership.one': '{count} გადაყვანილია აბონემენტის გარეშე: ძველმა სისტემამ წაკითხვადი დასრულების თარიღი არ მოგვცა, ამიტომ რეცეფცია მას აბონემენტს მიჰყიდის',
  'access.harvest.result.noMembership.other': '{count} გადაყვანილია აბონემენტის გარეშე: ძველმა სისტემამ წაკითხვადი დასრულების თარიღი არ მოგვცა, ამიტომ რეცეფცია მათ აბონემენტს მიჰყიდის',
  'access.harvest.result.ended.one': '{count} გადაყვანილია უკვე დასრულებული აბონემენტით',
  'access.harvest.result.ended.other': '{count} გადაყვანილია უკვე დასრულებული აბონემენტით',
  'access.harvest.result.left': 'გამოტოვებული',
  'access.harvest.outcome.PROMOTED': 'გადაყვანილია',
  'access.harvest.outcome.ALREADY_PROMOTED': 'უკვე წევრია',
  'access.harvest.outcome.NO_NAME': 'ძველ ჩანაწერში სახელი არ არის',
  'access.harvest.outcome.NO_CARD': 'ბარათის ნომერი არ არის',
  'access.harvest.outcome.CARD_IN_USE': 'ბარათი უკვე სხვა წევრს ეკუთვნის',
  'access.readers.purpose': 'რისთვის გამოიყენება',
  'access.readers.purpose.DOOR': 'კარი (წევრებისთვის იღება)',
  'access.readers.purpose.STAFF_CLOCK': 'პერსონალის აღრიცხვა (პერსონალის მოსვლასა და წასვლას აღრიცხავს, არასდროს იღება)',
  'access.readers.staffClock': 'პერსონალის აღრიცხვა',
};
